import { render, staticRenderFns } from "./UtilityNav.vue?vue&type=template&id=2054cc09"
import script from "./UtilityNav.vue?vue&type=script&lang=js"
export * from "./UtilityNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports